import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../views/login.vue"
import Profile from "../views/profile.vue"
import FileRepo from "../views/filerepo.vue"
import BPLONew from "../views/bplo_new.vue"
import BPLORenewal from "../views/bplo_renewal.vue"
import BPLORetirement from "../views/bplo_retirement.vue"
import PaymentTest from "../views/payment_test.vue"
// import NationlinkPayment from "../views/nationlinkpayment.vue"
import PaymentStatus from "../views/payment_status.vue"
// current
// import BPLOPayment from "../views/payments/bplo.vue"
// import RPTPayment from "../views/payments/rpt.vue"
// ub
import BPLOPayment from "../views/payments/bplo_ub.vue"
import RPTPayment from "../views/payments/rpt_ub.vue"
// end
import TransactionPayments from "../views/payments/transactions"
import COATransactionPayments from "../views/payments/transactions_coa"
import AccountActivation from "../views/accountactivation"
import SessionVerification from "../views/sessionverify"
import SessionLogout from "../views/sessionlogout"
import DocumentApproving from "../views/documentapproving"
import DocumentApproval from "../views/documentapproval"
import Dashboard from "../views/dashboard"
import ListOfAllTransactions from "../views/payments/allpayments"
// current
// import CHISSPayment from "../views/payments/chiss"
// ub
import CHISSPayment from "../views/payments/chiss_ub"
// end

// Claims
import TDNClaims from "../views/tdnclaims"
import BusinessClaims from "../views/businessclaims"
import TDNClaimsApproval from "../views/tdnclaimsapproval"
import BusinessClaimsApproval from "../views/businessclaimsapproval"
// End

// RPT Clearance
// current
// import RPTClearance from "../views/payments/rptclearance"
// ub
import RPTClearance from "../views/payments/rptclearance_ub"
// End

// Fortunepay testing
import Fortunepay from "../views/payments/fortunepay"
// end

// EOR
import eOR from "../views/payments/paymenteor"
// end

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'login',
        component: Login,
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
    },
    {
        path: '/filerepo',
        name: 'filerepo',
        component: FileRepo,
    },
    {
        path: '/bplonew',
        name: 'bplonew',
        component: BPLONew,
    },
    {
        path: '/bplorenewal',
        name: 'bplorenewal',
        component: BPLORenewal,
    },
    {
        path: '/bploretirement',
        name: 'bploretirement',
        component: BPLORetirement,
    },
    {
        path: '/payment/:requestid',
        name: 'payment',
        component: PaymentTest,
    },
    {
        path: '/payments/eor/:TransactionId',
        name: 'paymenteor',
        component: eOR,
    },
    // {
    //     path: '/payment/:requestid',
    //     name: 'payment',
    //     component: NationlinkPayment,
    // },
    {
        path: '/paymentstatus/:requestid',
        name: 'paymentstatus',
        component: PaymentStatus,
    },
    {
        path: '/bplopayment',
        name: 'bplopayment',
        component: BPLOPayment,
    },
    {
        path: '/bplopayment/:controlnumber',
        name: 'bplopaymentwithcontrolnumber',
        component: BPLOPayment,
    },
    {
        path: '/rptpayment',
        name: 'rptpayment',
        component: RPTPayment,
    },
    {
        path: '/onlinepaymentransactions',
        name: 'onlinepaymentransactions',
        component: TransactionPayments,
    },
    {
        path: '/onlinepaymentransactions_coa',
        name: 'onlinepaymentransactions_coa',
        component: COATransactionPayments,
    },
    {
        path: '/activateacct/:ctzncode',
        name: 'activateacct',
        component: AccountActivation,
    },
    {
        path: '/sessionverify/:authid',
        name: 'sessionverify',
        component: SessionVerification,
    },
    {
        path: '/logout',
        name: 'logout',
        component: SessionLogout,
    },
    {
        path: '/documentapproving',
        name: 'documentapproving',
        component: DocumentApproving,
    },
    {
        path: '/documentapproval',
        name: 'documentapproval',
        component: DocumentApproval,
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
    },
    {
        path: '/listofalltransactions',
        name: 'listofalltransactions',
        component: ListOfAllTransactions,
    },
    {
        path: '/chisspayment/:txn_number',
        name: 'chisspayment',
        component: CHISSPayment,
    },
    // claims
    {
        path: '/tdnclaims',
        name: 'tdnclaims',
        component: TDNClaims,
    },
    {
        path: '/bizclaims',
        name: 'bizclaims',
        component: BusinessClaims,
    },
    {
        path: '/tdnclaimsapproval',
        name: 'tdnclaimsapproval',
        component: TDNClaimsApproval,
    },
    {
        path: '/bizclaimsapproval',
        name: 'bizclaimsapproval',
        component: BusinessClaimsApproval,
    },
    {
        path: '/rptclearance',
        name: 'rptclearance',
        component: RPTClearance,
    },

    {
        path: '/fortunepay/:requestid',
        name: 'fortunepay',
        component: Fortunepay,
    },
    // end
]

const router = new VueRouter({
    // root: '/Tuguegarao-CRM/',
    // mode: 'history',
    mode: 'hash',
    base: process.env.BASE_URL, // testing
    // base: '/academ-e-notebook/', // local
    // base: '/academ-e/notebook/', // test server
    // base: '/Tuguegarao-CRM-User/', // tugue-server
    // base: 'citizen',
    // base: '/Dev', // dev
    routes, // short for `routes: routes`,
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
})

export default router